{
    "Accessibility menu": "Menú de accesibilidad",
    "Close": "Cerrar",
    "Content adjustments": "Ajustes de Contenido",
    "Navigation adjustments": "Ajustes de Navegación",
    "Text Align": "Alineación del texto",
    "Align Left": "Alinear a la izquierda",
    "Align Center": "Centrar",
    "Align Right": "Alinear a la derecha",
    "Adjust Font Size": "Ajustar Tamaño de Fuente",
    "Highlight Title": "Resaltar Título",
    "Highlight Links": "Resaltar Enlaces",
    "Readable Font": "Fuente Legible",
    "Colour adjustments": "Ajustes de Color",
    "Dark Contrast": "Contraste Oscuro",
    "Light Contrast": "Contraste Claro",
    "High Contrast": "Alto Contraste",
    "High Saturation": "Alta Saturación",
    "Low Saturation": "Baja Saturación",
    "Monochrome": "Monocromo",
    "Tools": "Herramientas",
    "Reading Guide": "Guía de Lectura",
    "Big Cursor": "Cursor Grande",
    "Increase Font Size": "Aumentar Tamaño de Fuente",
    "Decrease Font Size": "Disminuir Tamaño de Fuente",
    "Letter Spacing": "Espaciado entre Letras",
    "Line Height": "Altura de Línea",
    "Font Weight": "Peso de Fuente",
    "Dyslexia Font": "Fuente para Dislexia",
    "Language": "Idioma",
    "Accessibility widget": "Abrir menú de accesibilidad",
    "Accessibility Profiles": "Perfiles de Accesibilidad",
    "Cognitive Disability": "Discapacidad Cognitiva",
    "Seizure Safe": "Seguro para Epilepsia",
    "Accessibility statement": "Declaración de Accesibilidad",
    "ADHD": "TDAH",
    "Low Vision": "Baja visión",
    "Pause Animations": "Detener Animaciones",
    "Animation paused": "Animación en pausa",
    "Reset all settings": "Restablecer Configuración",
    "Shortcut:": "Atajo:",
    "Epilepsy Safe Mode": "Modo seguro para epilepsia",
    "Mute sounds": "Silenciar sonidos",
    "Page read": "Lectura de la página",
    "Page read controls": "Controles de lectura",
    "Pause": "Pausar",
    "Resume": "Reanudar",
    "Stop": "Detener",
    "Settings": "Ajustes",
    "Speed": "Velocidad",
    "Voice": "Voz",
    "Close accessibility menu": "Cerrar el menú de accesibilidad",
    "Back to accessibility menu": "Volver al menú de accesibilidad",
    "Search languages": "Buscar idiomas",
    "Selected language": "Idioma seleccionado",
    "View accessibility statement (opens in new window)": "Ver la declaración de accesibilidad (se abre en una nueva ventana)",
    "Visit CookieYes website (opens in new window)": "Visitar el sitio web de CookieYes (se abre en una nueva ventana)",
    "Reset all accessibility settings to default": "Restablecer todos los ajustes de accesibilidad"
}
